import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';

@Injectable()
export class BrowserGuard implements CanActivate {
    private readonly browserSupportedVersions: {type: string, version: string}[] = [
        { type: "Chrome", version: "53" },
         { type: "Safari", version: "10.1" },
         { type: "Edge", version: "13" },
         { type: "Firefox", version: "45" }
       ];
    
    private browserVersion: string = "";
    private browserName: string = "";
    
    constructor(private readonly router: Router, private readonly route: ActivatedRoute) {
        this.getBrowserInfo();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.checkSupportedBrowser()) {
            return true;
        }
        else {
            this.router.navigate(["nosupport"], {relativeTo: this.route})
            return false;
        }
    }

    public canShow(): boolean {
      return this.checkSupportedBrowser();
    }

    private checkSupportedBrowser(): boolean {
        let browserSupported = false;
        const supportedBrowserItem = this.browserSupportedVersions.filter((x) => {
          return x.type === this.browserName;
        });
        if (
          supportedBrowserItem &&
          supportedBrowserItem != null &&
          supportedBrowserItem.length > 0
        ) {
          const majorversion = this.browserVersion
            ? this.browserVersion.indexOf(".") !== -1
              ? parseInt(this.browserVersion.substr(0, this.browserVersion.indexOf(".")), 10)
              : parseInt(this.browserVersion, 10)
            : 0;
          if (majorversion >= parseInt(supportedBrowserItem[0].version, 10)) {
            browserSupported = true;
          }
        }
        return browserSupported;
    }

    private getBrowserInfo() {
        const objAgent = navigator.userAgent;
        let objfullVersion  = "0";
        let  objOffsetVersion ;
        let ix;
        // Edge
        if ((objOffsetVersion = objAgent.indexOf("Edge")) !== -1) {
            objfullVersion = this.checkIfEdgeBrowser(objAgent, objOffsetVersion);
        } else if ((objOffsetVersion = objAgent.indexOf("Chrome")) !== -1) {
          // Chrome
          ({ ix, objfullVersion } = this.checkIfChromeBrowser(ix, objAgent, objfullVersion, objOffsetVersion)); //nosonar
        } else if ((objOffsetVersion = objAgent.indexOf("MSIE")) !== -1 ||
          (objOffsetVersion = objAgent.indexOf(".NET")) !== -1
        ) {
          // In Microsoft internet explorer
          ({ ix, objfullVersion } = this.checkIfIEBrowser(ix, objAgent, objfullVersion, objOffsetVersion)); //nosonar
        } else if ((objOffsetVersion = objAgent.indexOf("Firefox")) !== -1) {
           // In Firefox
           objfullVersion = this.checkIfFirefoxBrowser(objAgent, objOffsetVersion);
        } else if ((objOffsetVersion = objAgent.indexOf("Safari")) !== -1) {
            // In Safari
          ({ objfullVersion, objOffsetVersion } = this.checkIfSafariBrowser(objAgent, objOffsetVersion)); //nosonar
        } else {
          // For other browser "name/version" is at the end of userAgent
          this.browserName = navigator.appName ? navigator.appName : objAgent;
        }
        this.browserVersion = objfullVersion;
    }

  private checkIfSafariBrowser(objAgent: string, objOffsetVersion: any) {
    this.browserName = "Safari";
    let objfullVersion = objAgent.substring(objOffsetVersion + 7);
    if ((objOffsetVersion = objAgent.indexOf("Version")) !== -1) {
      objfullVersion = objAgent.substring(objOffsetVersion + 8);
    }
    return { objfullVersion, objOffsetVersion };
  }

  private checkIfFirefoxBrowser(objAgent: string, objOffsetVersion: any) {
    this.browserName = "Firefox";
    const objfullVersion = objAgent.substring(objOffsetVersion + 8);
    return objfullVersion;
  }

  private checkIfIEBrowser(ix: any, objAgent: string, objfullVersion: string, objOffsetVersion: any) {
    this.browserName = "Microsoft Internet Explorer";
    if ((ix = objAgent.indexOf("rv:") !== -1)) { //nosonar
      ix = objAgent.indexOf("rv:");
      objfullVersion = objAgent.substring(ix + 3, ix + 7);
    } else {
      objfullVersion = objAgent.substring(objOffsetVersion + 5);
    }
    return { ix, objfullVersion };
  }

  private checkIfChromeBrowser(ix: any, objAgent: string, objfullVersion: string, objOffsetVersion: any) {
    this.browserName = "Chrome";
    if ((ix = objAgent.indexOf("Safari") !== -1)) { //nosonar
      ix = objAgent.indexOf("Safari");
      objfullVersion = objAgent.substring(objOffsetVersion + 7, ix);
    } else {
      objfullVersion = objAgent.substring(objOffsetVersion + 7);
    }
    return { ix, objfullVersion };
  }

  private checkIfEdgeBrowser(objAgent: string, objOffsetVersion: any) {
    this.browserName = "Edge";
    const objfullVersion = objAgent.substring(objOffsetVersion + 5);
    return objfullVersion;
  }
}